export const SHOW_CONFIRM_DIALOG = 'confirmDialog/SHOW_CONFIRM_DIALOG'
export const HIDE_CONFIRM_DIALOG = 'confirmDialog/HIDE_CONFIRM_DIALOG'
export const SET_CONFIRM_DIALOG_OPTIONS =
  'confirmDialog/SET_CONFIRM_DIALOG_OPTIONS'

export default {
  SHOW_CONFIRM_DIALOG,
  HIDE_CONFIRM_DIALOG,
  SET_CONFIRM_DIALOG_OPTIONS
}
